import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"],
})
export class ButtonComponent implements OnInit {
  @Input()
  title: string;

  @Input()
  info: string;

  @Input()
  primary: boolean = false;

  @Input()
  big: boolean = false;

  @Input()
  disable: boolean = false;

  @Input()
  icon: string = "";

  @Output()
  buttonClick = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  onClick(): void {
    this.buttonClick.emit();
  }
}
